import React from "react";
import { Link } from "react-router-dom";
import LoginComponent from "../components/LoginComponent";
import logoDocLift from "../images/logoDocLift.png";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: 18, height: 18, fill: "#fff" }}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
  </svg>
);

const Login = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#ffffff", color: "#0f2920", fontFamily: "Inter, sans-serif" }}>
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          height: 64,
          padding: "0 40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "rgba(255,255,255,0.92)",
          backdropFilter: "blur(16px)",
          borderBottom: "1px solid #E2EAEB",
        }}
      >
        <Link
          to="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 9,
            fontSize: "1.2rem",
            fontWeight: 800,
            color: "#0F2920",
            textDecoration: "none",
            letterSpacing: "-0.02em",
          }}
        >
          <span
            style={{
              width: 34,
              height: 34,
              background: "#128C7E",
              borderRadius: 9,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(18,140,126,0.25)",
            }}
          >
            <WhatsAppIcon />
          </span>
          DocLift
        </Link>

        <Link
          to="/dashboard"
          style={{
            background: "#25D366",
            color: "#fff",
            padding: "9px 22px",
            borderRadius: 8,
            fontWeight: 600,
            fontSize: "0.875rem",
            textDecoration: "none",
            boxShadow: "0 1px 3px rgba(37,211,102,0.3)",
          }}
        >
          Get Started
        </Link>
      </nav>

      <main style={{ paddingTop: 100, paddingBottom: 60, background: "linear-gradient(160deg, #F0FAF6 0%, #FFFFFF 55%, #F5FCF8 100%)" }}>
        <LoginComponent />
      </main>

      <footer
        style={{
          background: "#0b2034",
          color: "#ffffff",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          padding: "26px 24px",
          textAlign: "center",
          letterSpacing: "-0.02em",
        }}
      >
        <span style={{ display: "inline-block", fontWeight: 800, fontSize: "1rem", marginRight: 10 }}>
          DocLift
        </span>
        <span style={{ color: "rgba(255,255,255,0.72)", fontSize: "0.78rem" }}>
          WhatsApp AI for small businesses · Built in India 🇮🇳
        </span>
      </footer>
    </div>
  );
};

export default Login;
